import { http, type HttpError } from "../http";
import { isRecord } from "../utils/dom";

export type HubRuntimeEnv = {
  clearTimeout: typeof window.clearTimeout;
  location: Pick<Location, "reload">;
  setTimeout: typeof window.setTimeout;
  WMUHaptic?: Window["WMUHaptic"];
};

export function defaultHubRuntimeEnv(): HubRuntimeEnv {
  return {
    clearTimeout: window.clearTimeout.bind(window),
    location: window.location,
    setTimeout: window.setTimeout.bind(window),
    WMUHaptic: window.WMUHaptic,
  };
}

export function toFormBody(data: FormData | URLSearchParams): URLSearchParams {
  if (data instanceof URLSearchParams) {
    return data;
  }
  const body = new URLSearchParams();
  data.forEach((value, key) => {
    body.append(key, typeof value === "string" ? value : value.name);
  });
  return body;
}

export async function postHubForm(url: string, data: FormData | URLSearchParams) {
  return http.post<unknown>(url, toFormBody(data), {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  });
}

export function readHubErrorMessage(error: HttpError, fallback: string): string {
  if (isRecord(error.body)) {
    if (isRecord(error.body.error) && typeof error.body.error.message === "string" && error.body.error.message.trim()) {
      return error.body.error.message.trim();
    }
    if (typeof error.body.message === "string" && error.body.message.trim()) {
      return error.body.message.trim();
    }
  }
  if (typeof error.body === "string" && error.body.trim()) {
    return error.body.trim();
  }
  return fallback;
}

export function unwrapHubData<T>(payload: unknown): T {
  if (isRecord(payload) && "data" in payload) {
    return payload.data as T;
  }
  return payload as T;
}

export function setHubFeedback(target: HTMLElement | null, message: string, isError: boolean): void {
  if (!(target instanceof HTMLElement)) {
    return;
  }
  target.textContent = message;
  target.style.color = isError ? "var(--danger)" : "var(--text-secondary)";
}
